export default ({
    namespaced: true,

    state: () => ({
        currentStep: 'Cadastro',
        steps: ['Cadastro', 'Responsáveis' ,'Planos', 'Beneficiários'],
    }),

    getters: {
        getStep(state){
            return state.currentStep
        },
        getSteps(state) {
            return state.steps
        }

    },

    mutations: {
        SET_STEP(state, step){
            state.currentStep = step
        }
    },

    actions: {
        setStep({commit}, step){
            commit('SET_STEP', step);
        }
    }

})